export function normalizeSalaryValue(value: unknown): number | null {
	if (value === null || value === undefined || value === "") {
		return null;
	}

	if (typeof value === "number") {
		return isNaN(value) ? null : value;
	}

	const digits = String(value).replace(/\D/g, "");
	if (digits) {
		return parseDigitsToCents(digits) / 100;
	}

	const cleaned = String(value)
		.replace(/[^0-9,.-]/g, "")
		.replace(/\./g, "")
		.replace(/,/g, ".");

	const parsed = parseFloat(cleaned);
	return isNaN(parsed) ? null : parsed;
}

export function parseDigitsToCents(digits: string): number {
	return digits ? parseInt(digits, 10) : 0;
}

export function numericToCents(value: number): number {
	return Math.round(value * 100);
}

export function formatCurrencyDisplayFromCents(cents: number): string {
	return (cents / 100).toLocaleString("pt-BR", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
}

export function formatSalaryForMask(value: unknown): string | null {
	const normalized = normalizeSalaryValue(value);
	if (normalized === null) {
		return null;
	}

	return formatCurrencyDisplayFromCents(numericToCents(normalized));
}

export function formatSalaryForIntegration(value: unknown): string {
	const normalized = normalizeSalaryValue(value);
	if (normalized === null) {
		return "";
	}

	return normalized.toFixed(2);
}
